import api from './index';

/**
 * Log in a user
 * @param {Object} credentials - User credentials
 * @param {string} credentials.email - User email
 * @param {string} credentials.password - User password
 * @returns {Promise<Object>} - User data and token
 */
export const login = async (credentials) => {
  const response = await api.post('/auth/login', credentials);
  
  if (response.data.token) {
    localStorage.setItem('authToken', response.data.token);
  }
  
  return response.data.user;
};

/**
 * Log out the current user
 * @returns {Promise<void>}
 */
export const logout = async () => {
  await api.post('/auth/logout');
  localStorage.removeItem('authToken');
};

/**
 * Check authentication status
 * @returns {Promise<Object>} - User data if authenticated
 */
export const checkAuthStatus = async () => {
  const response = await api.get('/status/auth');
  return response.data.user;
};

/**
 * Get the current user's profile
 * @returns {Promise<Object>} - User profile data
 */
export const getUserProfile = async () => {
  const response = await api.get('/auth/profile');
  return response.data.user;
};
